// @flow
import React from 'react';
import {connect} from 'react-redux';
import {Redirect} from 'react-router-dom';
import {login} from '../../actions/auth';
import Login from '../../components/Login/Login';

export type Props = {
  isAuthenticated: boolean,
  onLoginClick: Function,
};

const LoginContainer = ({isAuthenticated, onLoginClick}: Props) => (
  isAuthenticated
    ? (
      <Redirect to="/" />
    ) : (
      <Login onLoginClick={onLoginClick} />
    )
);

export default connect(
  ({auth: {isAuthenticated}}) => ({isAuthenticated}),
  dispatch => ({
    onLoginClick: (username, password) =>
      dispatch(login(username, password)),
  })
)(LoginContainer);



// WEBPACK FOOTER //
// ./src/containers/LoginContainer/LoginContainer.js